import { removeFromLocalStorage } from '@/core/lib/localstorage';
import { StorageConstants } from '@linkie/shared';
import { CONSENT_CATEGORY, type ConsentCategory } from '@/consent/contract';
import { hasConsent, onConsentChange } from '@/core/lib/consent';

const LEGACY_ANALYTICS_KEYS: string[] = [
  'linkie_session',
  'linkie_banner_session',
  'linkie_cta_session',
  'linkie_email_session',
].flatMap((scope) => [`${scope}_id`, `${scope}_timestamp`]);

const purgeLegacyAnalyticsKeys = () => {
  [...LEGACY_ANALYTICS_KEYS, 'linkie_tab_count'].forEach((key) => removeFromLocalStorage(key));
};

const PURGEABLE_PREFIXES: Partial<Record<string, string[]>> = {
  [CONSENT_CATEGORY.FUNCTIONAL]: [StorageConstants.USER_SUBSCRIPTION_PREFIX],
};

const purgeByPrefix = (prefixes: string[]) => {
  try {
    Object.keys(localStorage)
      .filter((key) => prefixes.some((prefix) => key.startsWith(prefix)))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage can be unavailable outright in some privacy modes.
  }
};

const PURGEABLE_KEYS: Partial<Record<string, string[]>> = {
  [CONSENT_CATEGORY.ANALYTICS]: [],
  [CONSENT_CATEGORY.FUNCTIONAL]: [],
  [CONSENT_CATEGORY.EMBEDS]: [],
  [CONSENT_CATEGORY.PERFORMANCE]: [],
  [CONSENT_CATEGORY.MARKETING]: [],
};

let previous: Record<string, boolean> | null = null;

const purge = () => {
  const current: Record<string, boolean> = {};

  Object.entries(PURGEABLE_KEYS).forEach(([category, keys]) => {
    const isGranted = hasConsent(category as ConsentCategory);
    current[category] = isGranted;

    if (!isGranted && (previous === null || previous[category] === true)) {
      keys?.forEach((key) => removeFromLocalStorage(key));

      const prefixes = PURGEABLE_PREFIXES[category];
      if (prefixes) purgeByPrefix(prefixes);
    }
  });

  previous = current;
};

export const initConsentPurge = (): void => {
  purgeLegacyAnalyticsKeys();
  purge();
  onConsentChange(purge);
};
